import { v4 as makeUuid } from 'uuid'
import { AxiosInstance } from 'axios'
import { IUrlUtils } from 'v2/modules/lib'

export interface IBccAccountServiceArgs {
  httpClient: AxiosInstance
  urlUtils: IUrlUtils
}

type FeatureFlags<T extends readonly string[]> = {
  feature_flags: { [K in T[number]]: boolean }
}

export const makeBccAccountService = ({ httpClient, urlUtils }: IBccAccountServiceArgs) => {
  const getAccountFeatures = async <T extends readonly string[]>(
    bccAccountId: string,
    features: T
  ): Promise<FeatureFlags<T>> => {
    const res = await httpClient.get(`/bcc-account-service/account/${urlUtils.urlEncode(bccAccountId)}/features`, {
      params: {
        flags: features.join(',')
      },
      headers: {
        'X-Request-ID': makeUuid()
      }
    })
    return res.data
  }

  return Object.freeze({
    getAccountFeatures
  })
}
